export default __webpack_public_path__ + "static/media/shopify.8b4a07db.png";